module.exports = __webpack_public_path__ + "img/logo-m2n.76c75af4.svg";